import React from 'react';
import '../../styles/RateCard.css';

const EmailMkt = () => {
    return (
        <section className="email-mkt-section py-5">
            <div className="container">
                <div className="row gx-5 align-items-center">

                    {/* Columna Izquierda */}
                    <div className="col-md-6 bg-dark-teal text-white p-5 rounded-start" data-aos="fade-right" data-aos-delay="200">
                        <h2 className="title text-white text-capitalize">
                            <span className="highlight-bg">Email</span> MKT
                        </h2>
                        <p className="mt-4">
                            El eBlast de BeHealth es una herramienta estratégica diseñada para conectar marcas con audiencias
                            específicas a través de contenido relevante y storytelling atractivo. Este formato permite maximizar
                            la visibilidad de tu mensaje en un entorno altamente segmentado y confiable.
                        </p>
                        <ul className="mt-4 custom-bullets">
                            <li>Contenido personalizado creado con storytelling alineado a tu marca.</li>
                            <li>Segmentación a bases de datos exclusivas y curadas por intereses relevantes.</li>
                            <li>Máxima visibilidad al ocupar espacios destacados como sponsor principal.</li>
                            <li>Métricas detalladas sobre la apertura, clics e interacción con el contenido.</li>
                        </ul>
                        <div className="tab-label mt-4">Contenido</div>
                    </div>

                    {/* Columna Derecha */}
                    <div className="col-md-6 bg-light-green p-5 rounded-end position-relative" data-aos="fade-left" data-aos-delay="200">

                        <div className='d-flex justify-content-center'>
                            <div className='position-relative z-0'>
                                <h3 className="subtitle-rate-card fw-bold text-center">Características</h3>

                                <div className='position-absolute top-100 start-50 translate-middle'>
                                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#439b6b" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                                </div>
                            </div>
                        </div>
                        <div className='reach mt-3 rounded p-3'>
                            <h4>Tipo de compra:</h4>
                            <p className="">
                                Por cantidad de envíos o suscriptores (destinatarios).
                            </p>
                        </div>
                        <div className="includes-box">
                            <div className='shadow-lg rounded p-4 mt-3'>
                                <h5 className="fw-bold text-teal">Incluye:</h5>
                                <ul className="ps-3 mt-2">
                                    <li>Audiencias seleccionadas de nuestras bases exclusivas, curadas por intereses relevantes 
                                        y comportamientos.</li>
                                    <li>Inclusión del eBlast en campañas cruzadas, amplificando su alcance con redes sociales 
                                        y sitio web.</li>
                                    <li>Análisis de resultados y recopilación de datos (historial) para ajustar futuros envíos 
                                        y mejorar el impacto.</li>
                                </ul>
                            </div>
                        </div>

                        <div className='w-100 d-flex justify-content-center'>
                            <div className="investment-box bg-teal text-white p-3 mt-4 rounded shadow-lg">
                                <strong>Inversión:</strong><br />
                                A cotizar.
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default EmailMkt;
